import { Injectable } from '@angular/core';

/**
 * Per-process form-value snapshot store.
 *
 * Process components live under `*ngSwitchCase` (process dropdown) and inside
 * a `*ngIf`'d right-panel tab, so they get destroyed and rebuilt every time
 * the user switches tabs or picks a different process. Without this service,
 * the form resets to defaults each rebuild and any user edits are lost.
 *
 * Mirrors the lifecycle approach already used by `SubmissionStateService`:
 * a singleton `Map<processKey, value>` that outlives the volatile component
 * instances. In-memory only — values reset on full page reload.
 */
@Injectable({ providedIn: 'root' })
export class ProcessFormStateService {
  private snapshots = new Map<string, unknown>();

  get(key: string): unknown | undefined {
    return this.snapshots.get(key);
  }

  set(key: string, value: unknown): void {
    this.snapshots.set(key, value);
  }

  clear(key: string): void {
    this.snapshots.delete(key);
  }
}
